/**
 * A side note *within* the transcript — not a conversation turn.
 *
 * Needed since the question panel uses the same renderer as the main chat: it
 * has to add a remark that comes from no one in the conversation („Ich bin
 * mitgekommen — du bist jetzt in …"). It never goes to the server and carries
 * no timestamp, no bubble and no actions — and it should read that way too:
 * grey, small, italic, in the message column.
 *
 * It lives here and not in the panel because `ChatConversation` renders it:
 * the list decides what may stand between two messages, not the caller. The
 * main chat produces no such lines today — the server does not know the
 * message type.
 */

import React from 'react';

interface ChatPanelNoteProps {
    children: React.ReactNode;
    /** `data-testid` of the line — the caller brings its own. */
    testId?: string;
}

export const ChatPanelNote = ({ children, testId }: ChatPanelNoteProps) => (
    <div
        data-testid={testId ?? 'chat-panel-note'}
        data-chat-panel-note='true'
        className='px-[30px] text-[11px] italic leading-normal text-[var(--oa-fg-4)] max-sm:px-1'
    >
        {children}
    </div>
);
